//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 月度余额
const monthCashBalanceList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/monthCashBalance/list.vue')),
    'monthCashBalanceList'
  );
const monthCashBalanceAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/monthCashBalance/add.vue')),
    'monthCashBalanceAdd'
  );
// 利率
const interestRateList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestRate/list.vue')),
    'interestRateList'
  );
const interestRateAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestRate/add.vue')),
    'interestRateAdd'
  );

// 利率-海宁
const interestRateListHN = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestRateHN/list.vue')),
    'interestRateListHN'
  );
const interestRateAddHN = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestRateHN/add.vue')),
    'interestRateAddHN'
  );

// 资金计息单据池-现金
const interOrderCash = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/cash/list.vue')),
    'interOrderCash'
  );
// 资金计息单据池-应收票据
const interOrderBillReceivable = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/billReceivable/list.vue')),
    'interOrderBillReceivable'
  );
// 资金计息单据池-自开票据
const interOrderBillSince = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/billSince/list.vue')),
    'interOrderBillSince'
  );
// 资金计息单据池-信用证
const interOrderCL = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/CL/list.vue')),
    'interOrderCL'
  );
// 资金计息单据池-贸易融资
const interOrderTF = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/TF/list.vue')),
    'interOrderTF'
  );
const interOrderTFAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/TF/add.vue')),
    'interOrderTFAdd'
  );
// 资金计息单据池-海宁订单
const interOrderHN = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/HN/list.vue')),
    'interOrderHN'
  );
// 资金计息单据池-转款单
const interOrderTransfer = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interOrderPool/transfer/list.vue')),
    'interOrderTransfer'
  );

// 资金计息池-现金
const interCash = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interPool/cash/list.vue')),
    'interCash'
  );
// 资金计息池-应收票据
const interBillReceivable = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interPool/billReceivable/list.vue')),
    'interBillReceivable'
  );
// 资金计息池-自开票据
const interBillSince = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interPool/billSince/list.vue')),
    'interBillSince'
  );
// 资金计息池-信用证
const interCL = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interPool/CL/list.vue')),
    'interCL'
  );
// 资金计息池-贸易融资
const interTF = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interPool/TF/list.vue')),
    'interTF'
  );

// 银行
const interestBankList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestBank/list.vue')),
    'interestBankList'
  );
const interestBankAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestBank/add.vue')),
    'interestBankAdd'
  );

// 资金计息日报表
const interestDailyReport = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestDailyReport/list.vue')),
    'interestDailyReport'
  );

// 资金计息汇总表-海宁
const interestSumReportHN = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestReportHN/sumList.vue')),
    'interestSumReportHN'
  );

// 资金计息明细表-海宁
const interestDetailReportHN = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/interestReportHN/detailList.vue')),
    'interestDetailReportHN'
  );

// 业务单据类型配置
const businessType = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/config/businessType/list.vue')),
    'businessType'
  );
// 计息单据类型配置
const interOrderType = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/config/interOrderType/list.vue')),
    'interOrderType'
  );
// 高级配置
const advanced = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/config/advanced/list.vue')),
    'advanced'
  );
// 资金计息池-转款单
const interTransfer = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/moneyDraw/fundPool/interPool/transfer/list.vue')),
    'interTransfer'
  );

const moneyDrawRouter = {
  path: '/moneyDraw',
  component: index,
  children: [
    {
      path: 'monthCashBalanceList',
      name: 'monthCashBalanceList',
      component: monthCashBalanceList,
      meta: {
        keepAlive: true,
        title: '月初现金余额维护',
      },
    },
    {
      path: 'monthCashBalanceAdd',
      name: 'monthCashBalanceAdd',
      component: monthCashBalanceAdd,
      meta: {
        keepAlive: true,
        title: '月初现金余额新增',
      },
    },
    {
      path: 'interestRateList',
      name: 'interestRateList',
      component: interestRateList,
      meta: {
        keepAlive: true,
        title: '利率维护',
      },
    },
    {
      path: 'interestRateAdd',
      name: 'interestRateAdd',
      component: interestRateAdd,
      meta: {
        keepAlive: true,
        title: '利率新增',
      },
    },
    {
      path: 'interestRateListHN',
      name: 'interestRateListHN',
      component: interestRateListHN,
      meta: {
        keepAlive: true,
        title: '海宁利率维护',
      },
    },
    {
      path: 'interestRateAddHN',
      name: 'interestRateAddHN',
      component: interestRateAddHN,
      meta: {
        keepAlive: true,
        title: '海宁利率新增',
      },
    },
    {
      path: 'interOrderCash',
      name: 'interOrderCash',
      component: interOrderCash,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-现金',
      },
    },
    {
      path: 'interOrderTransfer',
      name: 'interOrderTransfer',
      component: interOrderTransfer,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-转款单',
      },
    },
    {
      path: 'interOrderBillReceivable',
      name: 'interOrderBillReceivable',
      component: interOrderBillReceivable,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-应收票据',
      },
    },
    {
      path: 'interOrderBillSince',
      name: 'interOrderBillSince',
      component: interOrderBillSince,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-自开票据',
      },
    },
    {
      path: 'interOrderCL',
      name: 'interOrderCL',
      component: interOrderCL,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-信用证',
      },
    },
    {
      path: 'interOrderTF',
      name: 'interOrderTF',
      component: interOrderTF,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-贸易融资',
      },
    },
    {
      path: 'interOrderTFAdd',
      name: 'interOrderTFAdd',
      component: interOrderTFAdd,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-贸易融资新增',
      },
    },
    {
      path: 'interOrderHN',
      name: 'interOrderHN',
      component: interOrderHN,
      meta: {
        keepAlive: true,
        title: '资金计息单据池-海宁订单',
      },
    },
    {
      path: 'interCash',
      name: 'interCash',
      component: interCash,
      meta: {
        keepAlive: true,
        title: '资金计息池-现金',
      },
    },
    {
      path: 'interTransfer',
      name: 'interTransfer',
      component: interTransfer,
      meta: {
        keepAlive: true,
        title: '资金计息池-转款单',
      },
    },
    {
      path: 'interBillReceivable',
      name: 'interBillReceivable',
      component: interBillReceivable,
      meta: {
        keepAlive: true,
        title: '资金计息池-应收票据',
      },
    },
    {
      path: 'interBillSince',
      name: 'interBillSince',
      component: interBillSince,
      meta: {
        keepAlive: true,
        title: '资金计息池-自开票据',
      },
    },
    {
      path: 'interCL',
      name: 'interCL',
      component: interCL,
      meta: {
        keepAlive: true,
        title: '资金计息池-信用证',
      },
    },
    {
      path: 'interTF',
      name: 'interTF',
      component: interTF,
      meta: {
        keepAlive: true,
        title: '资金计息池-贸易融资',
      },
    },
    {
      path: 'interestBankList',
      name: 'interestBankList',
      component: interestBankList,
      meta: {
        keepAlive: true,
        title: '银行维护',
      },
    },
    {
      path: 'interestDailyReport',
      name: 'interestDailyReport',
      component: interestDailyReport,
      meta: {
        keepAlive: true,
        title: '资金计息日报表',
      },
    },
    {
      path: 'interestSumReportHN',
      name: 'interestSumReportHN',
      component: interestSumReportHN,
      meta: {
        keepAlive: true,
        title: '海宁资金计息汇总表',
      },
    },
    {
      path: 'interestDetailReportHN',
      name: 'interestDetailReportHN',
      component: interestDetailReportHN,
      meta: {
        keepAlive: true,
        title: '海宁资金计息明细表',
      },
    },
    {
      path: 'interestBankAdd',
      name: 'interestBankAdd',
      component: interestBankAdd,
      meta: {
        keepAlive: true,
        title: '银行新增',
      },
    },
    {
      path: 'businessType',
      name: 'businessType',
      component: businessType,
      meta: {
        keepAlive: true,
        title: '业务单据类型配置',
      },
    },
    {
      path: 'interOrderType',
      name: 'interOrderType',
      component: interOrderType,
      meta: {
        keepAlive: true,
        title: '计息单据类型配置',
      },
    },
    {
      path: 'advanced',
      name: 'advanced',
      component: advanced,
      meta: {
        keepAlive: true,
        title: '高级配置',
      },
    },
  ],
};
export default moneyDrawRouter;
